export default __webpack_public_path__ + "static/media/bar-chart.5a0adea3.svg";